import React, { useState, useCallback, useEffect } from "react"
import { Form, Button, Row, Col, Card, Spinner } from "react-bootstrap"
import { useNavigate, Link } from "react-router-dom"
import { toast } from "react-toastify"
import useAuthAxios from "../hooks/useAuthAxios"
import Footer from "../components/layout/Footer"
import logo from "../assets/images/logo.jpg"
import { useAuth } from "../context/AuthContext"
import { validateEmail } from "../utils/validationUtils"

const ForgotPassword = () => {
  const [email, setEmail] = useState("")
  const [isSubmitting, setIsSubmitting] = useState(false)
  const [isSubmitted, setIsSubmitted] = useState(false)
  const [isValidEmail, setIsValidEmail] = useState(false)
  const [emailError, setEmailError] = useState("")
  const navigate = useNavigate()
  const { post } = useAuthAxios()
  const { isAuthenticated } = useAuth()

  useEffect(() => {
    if (isAuthenticated) {
      navigate("/")
    }
  }, [isAuthenticated, navigate])

  // Handle email input change with validation
  const handleEmailChange = e => {
    const newEmail = e.target.value
    setEmail(newEmail)

    const validation = validateEmail(newEmail)
    setIsValidEmail(validation.isValid)
    setEmailError(validation.error)
  }

  const handleSubmit = useCallback(
    async e => {
      e.preventDefault()
      setIsSubmitting(true)

      try {
        const response = await post("/forgot-password", { email })

        if (response.success) {
          setIsSubmitted(true)
        }
      } catch (error) {
        toast.error("Παρουσιάστηκε σφάλμα κατά την αποστολή της φόρμας.")
      } finally {
        setIsSubmitting(false)
      }
    },
    [email, post]
  )

  if (isSubmitted) {
    return (
      <div className="grid-background registration-page">
        <div className="min-vh-100 d-flex flex-column registration-page">
          <div className="flex-grow-1 d-flex align-items-center py-5">
            <div className="container-fluid">
              <Row className="justify-content-center">
                <Col xs={12} md={8} lg={6} xl={5}>
                  <div className="text-center mb-4">
                    <Link to="/">
                      <img src={logo} alt="eGarages logo" className="registration-logo" />
                    </Link>
                  </div>
                  <Card className="content-glass">
                    <Card.Body className="p-4 text-center">
                      <div className="mb-4">
                        <i className="fas fa-envelope fa-3x text-primary mb-3"></i>
                        <h4 className="mb-3">Ελέγξτε το Email σας</h4>
                        <p className="text-muted">
                          Εφόσον υπάρχει χρήστης με το email που καταχωρήσατε, θα λάβετε e-mail με οδηγίες για
                          την επαναφορά του κωδικού σας άμεσα.
                        </p>
                      </div>
                      <div className="d-grid">
                        <Link to="/login">Επιστροφή στη Σύνδεση</Link>
                      </div>
                    </Card.Body>
                  </Card>
                </Col>
              </Row>
            </div>
          </div>
          <Footer />
        </div>
      </div>
    )
  }

  return (
    <div className="grid-background registration-page">
      <div className="min-vh-100 d-flex flex-column registration-page">
        <div className="flex-grow-1 d-flex align-items-center py-5">
          <div className="container-fluid">
            <Row className="justify-content-center">
              <Col xs={12} md={8} lg={6} xl={5}>
                <div className="text-center mb-4">
                  <Link to="/">
                    <img src={logo} alt="eGarages logo" className="registration-logo" />
                  </Link>
                </div>
                <Card className="content-glass">
                  <Card.Header>
                    <h4 className="mb-0 text-center">Ανάκτηση Κωδικού</h4>
                  </Card.Header>
                  <Card.Body className="p-4">
                    <Form onSubmit={handleSubmit}>
                      <Form.Group className="mb-4">
                        <Form.Label>Email</Form.Label>
                        <Form.Control
                          type="email"
                          placeholder="Εισάγετε το email σας"
                          value={email}
                          onChange={handleEmailChange}
                          isInvalid={email.length > 0 && !isValidEmail}
                          required
                        />
                        <Form.Control.Feedback type="invalid">{emailError}</Form.Control.Feedback>
                      </Form.Group>

                      <div className="d-grid mb-3">
                        <Button
                          type="submit"
                          variant="primary"
                          size="lg"
                          disabled={isSubmitting || !isValidEmail || !email.trim()}>
                          {isSubmitting ? <Spinner animation="border" size="sm" /> : "Αποστολή Οδηγιών"}
                        </Button>
                      </div>

                      <div className="text-center">
                        <Link to="/login">Επιστροφή στη Σύνδεση</Link>
                      </div>
                    </Form>
                  </Card.Body>
                </Card>
              </Col>
            </Row>
          </div>
        </div>
        <Footer />
      </div>
    </div>
  )
}

export default ForgotPassword
